var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('menu-button',{attrs:{"is-active":_vm.isActive,"command":_vm.openAddLinkDialog,"title":"Add link","icon":"link"}}),_c('link-dialog',{attrs:{"title":"Apply link","is-visible":_vm.isVisible},on:{"close":_vm.closeAddLinkDialog,"click":_vm.addLink}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }